import { BacklinksChartColors } from "app/pages/digital-marketing/backlinks/shared/BacklinksConsts";
import { numFilter } from "app/pages/digital-marketing/backlinks/shared/BacklinksUtils";
import type { GranularityNames } from "app/UtilitiesAndConstants/Constants/Moment";
import { translate } from "app/filters/i18nFilter";
import { getChartTooltipHeaders } from "app/pages/digital-marketing/backlinks/reports/overview/BacklinksOverviewConsts";
import { getBacklinksChartConfig } from "app/pages/digital-marketing/backlinks/reports/overview/components/BacklinksChart/BacklinksChartConfig";
import {
    BacklinksChartYAxisParams,
    getTooltipFormatter,
    getTooltipHeaderOverTime,
} from "app/pages/digital-marketing/backlinks/reports/overview/components/BacklinksChart/BacklinksChartUtils";
import { CompareModeTooltip } from "app/pages/website-analysis/TrafficAndEngagement/ChartTooltips/CommonChartTooltip";
import {
    dateFormatter,
    minVisitsAbbrFormatter,
} from "app/pages/website-analysis/TrafficAndEngagement/UtilityFunctionsAndConstants/UtilityFunctions";

const getChartTooltip = (props: any) => {
    return (
        <div data-automation="chart-tooltip">
            <CompareModeTooltip
                {...props}
                xFormatter={dateFormatter}
                yFormatter={minVisitsAbbrFormatter}
                name={""}
                tableHeaders={getChartTooltipHeaders()}
                totalAggregate={(...values: number[]) => values.reduce((acc, v) => acc + v, 0)}
                getTooltipHeader={getTooltipHeaderOverTime}
            />
        </div>
    );
};

export const getOverTimeChartConfig = (timeGranularity: GranularityNames, compareMode = false): Highcharts.Options => {
    const chartParams = {
        tooltip: {
            formatter: getTooltipFormatter(timeGranularity, getChartTooltip),
        },
        chart: {
            height: 295,
            marginLeft: 50,
        },
        yAxis: compareMode
            ? [
                  {
                      ...BacklinksChartYAxisParams,
                      opposite: false,
                      labels: {
                          formatter: ({ value }: { value: number }) => numFilter(value),
                          style: {
                              color: BacklinksChartColors.REFDOMAINS,
                          },
                      },
                      min: 0,
                  },
              ]
            : [
                  {
                      ...BacklinksChartYAxisParams,
                      opposite: true,
                      labels: {
                          formatter: ({ value }: { value: number }) => numFilter(value),
                          style: {
                              color: BacklinksChartColors.BACKLINKS,
                          },
                      },
                      min: 0,
                      title: {
                          text: translate("backlinks.overview.referringGraph.axis.backlinks.title"),
                          align: "high",
                          y: -25,
                          x: 5,
                          offset: 0,
                          rotation: 0, // no rotation of the label
                          style: {
                              fontFamily: "Roboto",
                              fontSize: "11px",
                              fontWeight: "500",
                              color: BacklinksChartColors.BACKLINKS,
                          },
                      },
                  },
                  {
                      ...BacklinksChartYAxisParams,
                      labels: {
                          formatter: ({ value }: { value: number }) => numFilter(value),
                          style: {
                              color: BacklinksChartColors.REFDOMAINS,
                          },
                      },
                      min: 0,
                      title: {
                          text: translate("backlinks.overview.referringGraph.axis.referringDomains.title"),
                          align: "high",
                          y: -25,
                          x: 50,
                          offset: 0,
                          rotation: 0, //  no rotation of the label
                          style: {
                              fontSize: "11px",
                              fontFamily: "Roboto",
                              fontWeight: "500",
                              color: BacklinksChartColors.REFDOMAINS,
                          },
                      },
                  },
              ],
    };

    return getBacklinksChartConfig(timeGranularity, chartParams);
};
